import { ErrorMessage, FieldProps } from 'formik';
import * as React from 'react';
import { DropzoneOptions } from 'react-dropzone';
//import { maskArray } from 'react-text-mask';
import { Box, StyledInput, Dropzone } from '../';
import { StyledSystemProps } from '../../../theme/StyledSystemProps';
import { Label, Span } from '../../../typography';
import { SCREEN } from '../../../theme/breakpoints';

const isWeb = SCREEN.isWeb;

type FormGroupProps = Omit<FieldProps, 'meta'> &
  StyledSystemProps & {
    color?: string;
    defaultChecked?: boolean;
    checked?: boolean;
    disabled?: boolean;
    label?: string;
    pattern?: string;
    placeholder?: string;
    readOnly?: boolean;
    step?: string;
    type: string;
    value?: any;
    onChange?: (option: any) => void;
    onBlur?: (option: any) => void;
    autoComplete?: string;
    fileOptions?: DropzoneOptions;
    fileLoadHandler?: (
      form: any,
      fieldName: string,
      files: File[],
      setResult: (files: { name: string; description: string }[]) => void
    ) => Promise<void>;
    wrapperWidth?: string | number;
    mask?: any; //maskArray | ((value: string) => maskArray);
    hideErrorMessage?: boolean;
  };

const getValue = (type: string, value: any) => {
  if (type === 'number') {
    return value === undefined || value === null ? '' : value;
  } else if (type === 'checkbox') {
    return value === undefined || value === null ? false : value;
  }
  return value === null ? undefined : value;
};
class FormGroup extends React.Component<FormGroupProps, {}> {
  static defaultProps = {
    mb: 3,
    width: '100%',
    type: 'string',
    flex: 1,
    minWidth: isWeb ? '150px' : '100px',
  };

  render() {
    const {
      field,
      form,
      label,
      type,
      step,
      disabled,
      placeholder,
      readOnly,
      value,
      pattern,
      checked,
      fileOptions,
      fileLoadHandler,
      mask,
    } = this.props;
    const isCheckBox = type === 'checkbox';
    const isMobileCheckbox = !isWeb && isCheckBox;

    return (
      <Box {...this.props} flexDirection={isMobileCheckbox ? 'row' : 'column'}>
        <Label htmlFor={field.name} mt={isWeb ? undefined : 3} pl={isWeb ? undefined : 0} pr={isWeb ? undefined : 2}>
          {label}
        </Label>
        {type === 'file' ? (
          <Dropzone
            id={field.name}
            name={field.name}
            form={form}
            dropzoneOptions={fileOptions}
            onLoad={fileLoadHandler}
            filePrompt={placeholder}
          />
        ) : (
          <StyledInput
            disabled={isCheckBox ? readOnly : disabled}
            type={type}
            checked={checked}
            id={field.name}
            px={2}
            {...field}
            placeholder={placeholder}
            defaultChecked={this.props.defaultChecked}
            onChange={this.props.onChange}
            onBlur={this.props.onBlur}
            readOnly={readOnly}
            value={getValue(type, value)}
            pattern={pattern}
            step={step}
            width={isMobileCheckbox ? '40px' : this.props.width ? this.props.width.toString() : undefined}
            wrapperWidth={
              isMobileCheckbox ? '40px' : this.props.wrapperWidth ? this.props.wrapperWidth.toString() : undefined
            }
            color={this.props.color}
            height={this.props.height ? this.props.height.toString() : undefined}
            autoComplete={this.props.autoComplete}
            mask={mask}
          />
        )}
        {!this.props.hideErrorMessage && (
          <ErrorMessage name={field.name}>
            {msg => (
              <Span mt={2} color="error" textAlign="right">
                {msg}
              </Span>
            )}
          </ErrorMessage>
        )}
      </Box>
    );
  }
}

export default FormGroup;
